import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { listUserCaseOutput } from 'src/app/pages/cases/service/cases.service';

@Component({
  selector: 'app-card-cases',
  templateUrl: './card-cases.component.html',
  styleUrls: ['./card-cases.component.scss'],
})
export class CardCasesComponent implements OnInit {
  constructor() {}
  @Input() data!: listUserCaseOutput;
  @Input() selectedTab: number;

  @Output() acquireCase? = new EventEmitter<number>();

  @Output() getCaseDetails? = new EventEmitter<number>();

  ngOnInit(): void {}
}
